import { JSON_FORMAT, JSON_SUBSETS_KEY } from '../../constants';
import { ExportColumn, ExportFormat, ExportSection } from '../../types';
import { hasExportableSubsetSections } from '../hasExportableSubsetSections';

const findJsonReservedColumn = (
  sections: ExportSection[],
  masterSection: ExportSection | undefined,
  format: ExportFormat,
  isWithSubsetsMode: boolean
): ExportColumn | undefined => {
  if (format !== JSON_FORMAT || !isWithSubsetsMode) {
    return undefined;
  }

  if (!masterSection || !hasExportableSubsetSections(sections)) {
    return undefined;
  }

  return masterSection.columns.find(
    (column) => column.selected && column.name === JSON_SUBSETS_KEY
  );
};

export default findJsonReservedColumn;
